// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"23":"component---src-templates-legacy-page-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"23":"3cc850afe66d5f2ffdba","279":"8aca748f9cc7e8f849c6","453":"50e717fa0e2655e5ec79"}[chunkId] + ".js";
};